import { getCookie, setCookie } from "../../utils/cookie";

function setCookieAndReload(newVal) {
  setCookie("productionJigsaw", newVal, 2);

  const interval = window.setInterval(() => {
    const val = getCookie("productionJigsaw");
    if (`${val}` === `${newVal}`) {
      window.clearInterval(interval);
      window.location.reload();
    }
  }, 200);
}

export function pointToProd() {
  setCookieAndReload("true");
}

export function pointToDev() {
  setCookieAndReload("false");
}

export function isPointedToProd() {
  return getCookie("productionJigsaw") === "true";
}
